import * as React from "react";
import { Path, G, ClipPath, Defs, Rect, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const PTIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="PT" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#EF0000"
        fillRule="evenodd"
        d="M4 0h12v12H4V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#2F8D00"
        fillRule="evenodd"
        d="M0 0h6v12H0V0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={8}
        height={8}
        x={2}
        y={2}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M5.952 9.903c-2.13 0-3.857-1.747-3.857-3.903 0-2.156 1.727-3.904 3.857-3.904S9.81 3.844 9.81 6c0 2.156-1.726 3.903-3.857 3.903Z"
          clipRule="evenodd"
        />
      </Mask>
      <G fill="#FFE017" mask="url(#b)">
        <Path
          fillRule="evenodd"
          d="M5.714 2h.5v1.35h-.5V2ZM5.714 8.747h.5V10h-.5V8.747Z"
          clipRule="evenodd"
        />
        <Path d="m2.157 6.202-.14-.36C3.56 5.228 4.724 4.83 5.514 4.652a29.366 29.366 0 0 1 3.821-.583l.034.384c-1.372.125-2.63.316-3.771.575-.767.174-1.915.565-3.44 1.175Z" />
        <Path d="m9.57 3.832-.113.368c-1.166-.368-2.116-.527-2.846-.478l-.025-.384c.784-.053 1.778.113 2.984.494ZM9.974 5.89l-.216.318c-.594-.413-1.326-.62-2.201-.62v-.386c.948 0 1.756.229 2.417.688Z" />
        <Path d="m9.651 6.005.098.372c-1.28.347-2.484.544-3.609.59-1.132.047-2.452-.15-3.96-.59l.105-.371c1.472.43 2.752.621 3.84.576 1.095-.045 2.27-.237 3.526-.577Z" />
        <Path d="m9.506 7.818-.602.617c-1.145-1.143-2.152-1.96-3.017-2.452-.879-.5-2.025-1.007-3.437-1.52l.29-.816c1.453.528 2.642 1.054 3.567 1.58.94.534 2.004 1.398 3.199 2.59ZM2.73 8.167 2.5 7.858a4.644 4.644 0 0 1 .594-.361c.425-.215.852-.35 1.259-.362l.059-.001v.385l-.048.001c-.343.01-.72.13-1.1.322a4.262 4.262 0 0 0-.536.325Z" />
        <Path d="m2.906 8.301.096-.373c1.27.334 2.25.501 2.932.501.681 0 1.695-.197 3.034-.591l.106.37c-1.37.404-2.415.607-3.14.607-.721 0-1.73-.172-3.028-.514ZM2.411 4.847l.604-.616.883.887-.603.616-.884-.887Z" />
        <Path d="m7.418 7.924.449-.74 1.402.873-.45.739-1.401-.872Z" />
      </G>
      <Path
        fill="#F9E813"
        d="M5.953 2.096c2.13 0 3.856 1.748 3.856 3.904 0 2.155-1.726 3.904-3.856 3.904S2.095 8.155 2.095 6c0-2.156 1.727-3.904 3.858-3.904ZM6 2.674c-1.841 0-3.333 1.511-3.333 3.374 0 1.863 1.492 3.373 3.333 3.373 1.84 0 3.333-1.51 3.334-3.373C9.334 4.185 7.84 2.674 6 2.674Z"
      />
      <Path
        fill="#fff"
        d="M3.828 3.592v3.13c.206 1.24.9 1.86 2.083 1.86 1.182 0 1.877-.62 2.083-1.86v-3.13H3.828Z"
      />
      <Path
        fill="#C51918"
        d="M3.543 3.303h4.736v3.444l-.004.024c-.228 1.376-1.04 2.1-2.364 2.1-1.324 0-2.136-.724-2.364-2.1l-.004-.024V3.303Z"
      />
      <Path
        fill="#F7FCFF"
        d="M4.626 4.355h2.57v2.22s-.19 1.147-1.285 1.147c-1.094 0-1.285-1.147-1.285-1.147v-2.22Z"
      />
      <Path
        fill="#F9E813"
        fillRule="evenodd"
        d="M4 3.542h.361v.241H4v-.241Z"
        clipRule="evenodd"
      />
      <Path
        fill="#060101"
        fillRule="evenodd"
        d="M3.81 3.638h.666v.12H3.81v-.12Z"
        clipRule="evenodd"
      />
      <Path
        fill="#F9E813"
        fillRule="evenodd"
        d="M3.81 3.735h.36v.12h-.36v-.12ZM4.19 3.735h.362v.12H4.19v-.12ZM3.81 4.024h.24v.361h-.24v-.361ZM4.286 4.024h.24v.361h-.24v-.361ZM4.095 4.024h.12v.361h-.12v-.361Z"
        clipRule="evenodd"
      />
      <Path
        fill="#060101"
        fillRule="evenodd"
        d="M3.81 3.928h.666v.12H3.81v-.12ZM3.81 4.217h.666v.12H3.81v-.12Z"
        clipRule="evenodd"
      />
      <Path
        fill="#F9E813"
        fillRule="evenodd"
        d="M3.905 3.831h.12v.12h-.12v-.12ZM4.286 3.831h.12v.12h-.12v-.12ZM4.095 3.735h.12v.24h-.12v-.24ZM5.81 3.542h.36v.241h-.36v-.241Z"
        clipRule="evenodd"
      />
      <Path
        fill="#060101"
        fillRule="evenodd"
        d="M5.619 3.638h.667v.12h-.667v-.12Z"
        clipRule="evenodd"
      />
      <Path
        fill="#F9E813"
        fillRule="evenodd"
        d="M5.619 3.735h.361v.12H5.62v-.12ZM6 3.735h.361v.12H6v-.12ZM5.619 4.024h.241v.361h-.241v-.361ZM6.095 4.024h.241v.361h-.24v-.361ZM5.905 4.024h.12v.361h-.12v-.361Z"
        clipRule="evenodd"
      />
      <Path
        fill="#060101"
        fillRule="evenodd"
        d="M5.619 3.928h.667v.12h-.667v-.12ZM5.619 4.217h.667v.12h-.667v-.12Z"
        clipRule="evenodd"
      />
      <Path
        fill="#F9E813"
        fillRule="evenodd"
        d="M5.714 3.831h.12v.12h-.12v-.12ZM6.095 3.831h.12v.12h-.12v-.12ZM5.905 3.735h.12v.24h-.12v-.24ZM7.524 3.542h.361v.241h-.361v-.241Z"
        clipRule="evenodd"
      />
      <Path
        fill="#060101"
        fillRule="evenodd"
        d="M7.333 3.638H8v.12h-.667v-.12Z"
        clipRule="evenodd"
      />
      <Path
        fill="#F9E813"
        fillRule="evenodd"
        d="M7.333 3.735h.362v.12h-.362v-.12ZM7.714 3.735h.362v.12h-.362v-.12ZM7.333 4.024h.241v.361h-.24v-.361ZM7.81 4.024h.24v.361h-.24v-.361ZM7.619 4.024h.12v.361h-.12v-.361Z"
        clipRule="evenodd"
      />
      <Path
        fill="#060101"
        fillRule="evenodd"
        d="M7.333 3.928H8v.12h-.667v-.12ZM7.333 4.217H8v.12h-.667v-.12Z"
        clipRule="evenodd"
      />
      <Path
        fill="#F9E813"
        fillRule="evenodd"
        d="M7.428 3.831h.12v.12h-.12v-.12ZM7.81 3.831h.12v.12h-.12v-.12ZM7.619 3.735h.12v.24h-.12v-.24ZM7.524 5.277h.361v.24h-.361v-.24Z"
        clipRule="evenodd"
      />
      <Path
        fill="#060101"
        fillRule="evenodd"
        d="M7.333 5.373H8v.12h-.667v-.12Z"
        clipRule="evenodd"
      />
      <Path
        fill="#F9E813"
        fillRule="evenodd"
        d="M7.333 5.47h.362v.12h-.362v-.12ZM7.714 5.47h.362v.12h-.362v-.12ZM7.333 5.759h.241v.361h-.24V5.76ZM7.81 5.759h.24v.361h-.24V5.76ZM7.619 5.759h.12v.361h-.12V5.76Z"
        clipRule="evenodd"
      />
      <Path
        fill="#060101"
        fillRule="evenodd"
        d="M7.333 5.663H8v.12h-.667v-.12ZM7.333 5.952H8v.12h-.667v-.12Z"
        clipRule="evenodd"
      />
      <Path
        fill="#F9E813"
        fillRule="evenodd"
        d="M7.428 5.566h.12v.12h-.12v-.12ZM7.81 5.566h.12v.12h-.12v-.12ZM7.619 5.47h.12v.24h-.12v-.24ZM4 5.277h.361v.24H4v-.24Z"
        clipRule="evenodd"
      />
      <Path
        fill="#060101"
        fillRule="evenodd"
        d="M3.81 5.373h.666v.12H3.81v-.12Z"
        clipRule="evenodd"
      />
      <Path
        fill="#F9E813"
        fillRule="evenodd"
        d="M3.81 5.47h.36v.12h-.36v-.12ZM4.19 5.47h.362v.12H4.19v-.12ZM3.81 5.759h.24v.361h-.24V5.76ZM4.286 5.759h.24v.361h-.24V5.76ZM4.095 5.759h.12v.361h-.12V5.76Z"
        clipRule="evenodd"
      />
      <Path
        fill="#060101"
        fillRule="evenodd"
        d="M3.81 5.663h.666v.12H3.81v-.12ZM3.81 5.952h.666v.12H3.81v-.12Z"
        clipRule="evenodd"
      />
      <Path
        fill="#F9E813"
        fillRule="evenodd"
        d="M3.905 5.566h.12v.12h-.12v-.12ZM4.286 5.566h.12v.12h-.12v-.12ZM4.095 5.47h.12v.24h-.12v-.24ZM4.232 7.452l.232-.277.185.155-.233.277-.184-.155Z"
        clipRule="evenodd"
      />
      <Path
        fill="#060101"
        fillRule="evenodd"
        d="m4.183 7.66.429-.511.092.077-.428.511-.093-.077Z"
        clipRule="evenodd"
      />
      <Path
        fill="#F9E813"
        fillRule="evenodd"
        d="m4.257 7.722.232-.277.093.077-.233.277-.092-.077ZM4.502 7.43l.232-.277.093.077-.233.277-.092-.077ZM4.479 7.907l.154-.184.277.232-.155.185-.276-.233ZM4.785 7.542l.155-.184.276.232-.154.185-.277-.233ZM4.662 7.688l.078-.092.277.233-.078.092-.277-.233Z"
        clipRule="evenodd"
      />
      <Path
        fill="#060101"
        fillRule="evenodd"
        d="m4.405 7.846.428-.511.092.077-.428.511-.092-.077ZM4.626 8.031l.429-.51.092.077-.428.51-.093-.077Z"
        clipRule="evenodd"
      />
      <Path
        fill="#F9E813"
        fillRule="evenodd"
        d="m4.392 7.71.078-.092.092.078-.078.092-.092-.078ZM4.637 7.419l.077-.092.093.077-.078.092-.092-.077ZM4.44 7.503l.078-.092.185.155-.078.092-.184-.155ZM7.49 7.233l.231.277-.184.155-.232-.277.184-.155Z"
        clipRule="evenodd"
      />
      <Path
        fill="#060101"
        fillRule="evenodd"
        d="m7.293 7.149.428.51-.092.078-.428-.51.092-.078Z"
        clipRule="evenodd"
      />
      <Path
        fill="#F9E813"
        fillRule="evenodd"
        d="m7.219 7.21.232.278-.092.077-.232-.277.092-.077ZM7.464 7.502l.232.277-.092.078-.232-.277.092-.078ZM6.998 7.396l.154.185-.276.232-.155-.184.277-.233ZM7.304 7.761l.154.185-.276.232-.155-.184.277-.233ZM7.181 7.616l.078.092-.277.232-.078-.092.277-.232Z"
        clipRule="evenodd"
      />
      <Path
        fill="#060101"
        fillRule="evenodd"
        d="m7.071 7.335.429.51-.092.078-.429-.51.092-.078ZM6.85 7.52l.428.511-.092.078-.428-.511.092-.077Z"
        clipRule="evenodd"
      />
      <Path
        fill="#F9E813"
        fillRule="evenodd"
        d="m7.206 7.346.078.092-.092.077-.078-.092.092-.077ZM7.451 7.638l.078.092-.093.077-.077-.092.092-.077ZM7.403 7.43l.077.092-.184.155-.078-.092.185-.155Z"
        clipRule="evenodd"
      />
      <Path
        fill="#013399"
        d="M6.28 5.083s-.05.248-.33.248c-.282 0-.331-.248-.331-.248v-.481h.66v.48Zm-.47.001a.095.095 0 0 0-.095.096c0 .053.042.097.094.097a.096.096 0 0 0 .096-.097.096.096 0 0 0-.096-.096Zm.286 0A.096.096 0 0 0 6 5.18c0 .053.043.097.096.097a.096.096 0 0 0 .094-.097.095.095 0 0 0-.094-.096Zm-.144-.193a.096.096 0 0 0-.095.097c0 .053.043.096.095.096a.097.097 0 0 0 0-.193ZM5.809 4.7a.095.095 0 0 0-.094.095c0 .054.042.097.094.097a.096.096 0 0 0 0-.192Zm.287 0a.096.096 0 0 0 0 .192.096.096 0 0 0 .094-.097.095.095 0 0 0-.094-.095ZM6.28 6.143s-.05.248-.33.248a.323.323 0 0 1-.331-.248v-.48h.66v.48Zm-.47.001a.096.096 0 0 0-.095.097c0 .053.042.096.094.096a.097.097 0 0 0 0-.193Zm.286 0a.097.097 0 0 0 0 .193.096.096 0 0 0 .094-.096.096.096 0 0 0-.094-.097Zm-.144-.192a.096.096 0 0 0-.095.096.095.095 0 1 0 .19 0 .096.096 0 0 0-.095-.096Zm-.143-.193a.095.095 0 0 0-.094.096c0 .053.042.097.094.097a.096.096 0 0 0 .096-.097.096.096 0 0 0-.096-.096Zm.287 0A.096.096 0 0 0 6 5.855c0 .053.043.097.096.097a.096.096 0 0 0 .094-.097.095.095 0 0 0-.094-.096ZM7.136 6.143s-.049.248-.33.248c-.28 0-.33-.248-.33-.248v-.48h.66v.48Zm-.47.001a.096.096 0 0 0-.094.097c0 .053.042.096.095.096a.097.097 0 0 0 0-.193Zm.287 0a.097.097 0 0 0 0 .193.096.096 0 0 0 .094-.096.096.096 0 0 0-.094-.097Zm-.144-.192a.096.096 0 0 0-.095.096.095.095 0 1 0 .19 0 .096.096 0 0 0-.095-.096Zm-.142-.193a.095.095 0 0 0-.095.096c0 .053.042.097.095.097a.096.096 0 0 0 .095-.097.096.096 0 0 0-.095-.096Zm.286 0a.096.096 0 0 0-.096.096c0 .053.043.097.096.097a.096.096 0 0 0 .094-.097.095.095 0 0 0-.094-.096ZM5.422 6.143s-.049.248-.33.248a.323.323 0 0 1-.33-.248v-.48h.66v.48Zm-.47.001a.096.096 0 0 0-.094.097c0 .053.042.096.094.096a.097.097 0 0 0 0-.193Zm.286 0a.097.097 0 0 0 0 .193.096.096 0 0 0 .095-.096.096.096 0 0 0-.095-.097Zm-.143-.192A.096.096 0 0 0 5 6.048a.095.095 0 1 0 .19 0 .096.096 0 0 0-.095-.096Zm-.143-.193a.095.095 0 0 0-.094.096c0 .053.042.097.094.097a.096.096 0 0 0 .096-.097.096.096 0 0 0-.096-.096Zm.286 0a.096.096 0 0 0-.095.096c0 .053.043.097.095.097a.096.096 0 0 0 .095-.097.095.095 0 0 0-.095-.096ZM6.28 7.203s-.05.248-.33.248c-.282 0-.331-.248-.331-.248v-.48h.66v.48Zm-.47.002a.095.095 0 0 0-.095.096c0 .053.042.096.094.096a.096.096 0 0 0 .096-.096.096.096 0 0 0-.096-.096Zm.286 0A.096.096 0 0 0 6 7.301c0 .053.043.096.096.096a.096.096 0 0 0 .094-.096.095.095 0 0 0-.094-.096Zm-.144-.193a.096.096 0 0 0-.095.096c0 .053.043.097.095.097a.097.097 0 0 0 0-.193Zm-.143-.193a.095.095 0 0 0-.094.096c0 .053.042.097.094.097a.096.096 0 0 0 0-.192Zm.287 0a.096.096 0 0 0 0 .193.096.096 0 0 0 .094-.097.095.095 0 0 0-.094-.096Z"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
